<template>
	<div class="unishop-unifilter look-filter">
    <div>
      <div class="uf-filter-wrap">
        <div id="uf-name" class="uf-search">
          <div class="uf-search-box">
            <input
              class="input is-rounded"
              type="text"
              v-model="nombre"
              placeholder="Nombre..."
            >
            <div class="uf-reset" title="Reset" @click="nombre=''">
            </div>
          </div>
        </div>
      </div>
      <div class="uf-range-wrap">
        <div id="uf-price" class="uf-range">
          <v-checkbox
            v-model="validado"
            color="#2562a4"
            hide-details
          ><template v-slot:label>
              <div class="filter-check-label">Validado</div>
            </template>
          </v-checkbox>
        </div>
      </div>
      <div class="unishop-cart-buttons">
        <a class="unishop-button-secondary unishop-keep-shopping" @click="reset()">Reiniciar</a>
        <a class="unishop-button" @click="search()">Buscar</a>
      </div>	
    </div>
	</div>
</template>
<script>

export default {
	name: 'LookFiltro',
  // props: ['opId'],
	data () {
		return {
      validado: false,
      tiendas: this.$store.state.iniOps,
      nombre: '',
		}
	},
	mounted () {
    this.init()
    this.nombre = this.$store.state.userInfo.lookNombreSearched
    this.validado = this.$store.state.userInfo.lookValidadoSearched
	},
	methods: {
    init () {
      
    },
		search () {
      this.$store.commit('setLookNombreSearched', this.nombre);
      this.$store.commit('setLookLocalizadorSearched', '');
      this.$store.commit('setLookValidadoSearched', this.validado);
      this.$store.commit('setHasUserSearchedLook', this.$store.state.userInfo.hasLookSearched + 1);
      this.$store.commit('cambioPag', 1)
      this.$store.commit('showFiltro', false);
		},
		reset () {
      this.nombre = ''
      this.validado = false
      this.$store.commit('setLookNombreSearched', '')
      this.$store.commit('setLookValidadoSearched', false)
			this.$store.commit('cambioPag', 1)
      this.$store.commit('setHasUserSearchedLook', 0)
      this.$store.commit('showFiltro', false)
      
    },
	}
}
</script>